module.exports = __webpack_public_path__ + "img/b3-2.c274491.png";